<!--
 * @Description: 品牌厂商详情
 * @Author: zml
 * @Date: 2023-06-14 17:53:58
 * @LastEditors: zml
 * @LastEditTime: 2023-06-14 18:05:31
-->

<template>
  <div>
    <component :is="componentName"></component>
  </div>
</template>
<script>
import mixins from '@/utils/mixins'
export default {
  name: 'brandDetailPage',
  mixins: [mixins],

  data() {
    return {
      componentName: ''
    }
  },
  created() {
    this.initDom()
  },
  methods: {
    initDom() {
      switch (this.$templates()) {
        case 'themeTemplateFour':
          this.componentName = 'pageBrandFour'
          break
        default:
          this.componentName = ''
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>